<template>
  <el-dialog
      title="Xuất Excel "
      :visible.sync="dialogVisible"
      width="450"
      :before-close="closeDialog"
      :close-on-click-modal="false"
  >
    <el-row>
      <span style="display: flex; justify-content: center">Chọn khoảng thời gian</span>
      <el-date-picker
          style="width: 100%"
          value-format="yyyy-MM-dd"
          format="dd-MM-yyyy"
          v-model="valueDate"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="Ngày bắt đầu"
          end-placeholder="Ngày kết thúc"
          :picker-options="pickerOptions"
      >
      </el-date-picker>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close"/>
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
      >
        <i class="el-icon-circle-check"/>
        <span>Xuất Excel</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment/moment";
import TakeLeaveService from "@/services/TakeLeaveService";

export default {
  props: {
    dialogVisible: null,
    dataSearch: {
      idGrade: "",
      idClass: "",
      confirmStatus: "",
      dateSick: "",
      name: "",
    },
  },
  created() {
    console.log('Component đã được tạo!', this.dataSearch);
  },
  mounted() {
    console.log('Component đã được mount vào DOM!', this.dataSearch);
  },
  data() {
    return {
      pickerOptions: this.$funcCommon.quickOptionDate(),
      valueDate: [],
      styleCols1: [],
      styleCols2: [],
      loadingButton: false,
    };
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
      }, 300);
    },
    getStyleExcelStudent() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();
      let styleCol1 = {
        name: "A7:P7",
        style: {
          fill: {fgColor: {rgb: "ffff00"}},
          font,
          alignment,
          border,
        },
      };
      let styleCol2 = {
        name: "Q7:U7",
        style: {
          fill: {fgColor: {rgb: "ffb2bd"}},
          font,
          alignment,
          border,
        },
      };
      let styleCol3 = {
        name: "V7:AB7",
        style: {
          fill: {fgColor: {rgb: "78f388"}},
          font,
          alignment,
          border,
        },
      };
      //style1
      let styleCol4 = {
        name: ["A1"],
        style: {
          font: {color: {rgb: "ff0000"}, bold: true, sz: "18"},
        },
      };
      let styleCol5 = {
        name: ["A2", "A3", "A4", "A5", "A6"],
        style: {
          font: {bold: true, sz: "11"},
        },
      };
      this.styleCols2.push(styleCol1);
      this.styleCols2.push(styleCol2);
      this.styleCols2.push(styleCol3);

      this.styleCols1.push(styleCol4);
      this.styleCols1.push(styleCol5);
    },
    exportExcel() {
      this.getStyleExcelStudent();
      let myDate = moment(new Date()).format("DD-MM-YYYY hh:mm:ss");
      let fileNameExport = "DANH_SACH_XIN_NGHI"
      TakeLeaveService.exportExcelAbsent(
          this.valueDate,
          this.dataSearch.idGrade,
          this.dataSearch.idClass,
          this.dataSearch.confirmStatus,
          this.dataSearch.dateSick,
          this.dataSearch.name
      )
          .then((resp) => {
            import("@/services/ExportExcel")
                .then((excel) => {
                  let dataList = resp.data.data;
                  let fileName = `${fileNameExport}_${myDate}`;
                  const tHeader = [
                    "STT",
                    "Họ tên",
                    "Lớp học",
                    "Ngày gửi",
                    "Phản hồi",
                    "Nội dung",
                    "Ngày nghỉ",
                    "Số ngày nghỉ",
                    "Quá hạn",
                    "Trạng thái",
                  ];
                  const filterVal = [
                    "pro1",
                    "pro2",
                    "pro3",
                    "pro4",
                    "pro5",
                    "pro6",
                    "pro7",
                    "pro8",
                    "pro9",
                    "pro10"
                  ];
                  let columnList = [
                    {col: 5},
                    {col: 25},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 10},
                    {col: 20},
                  ];
                  excel.export_json_to_excel({
                    header: tHeader,
                    data: dataList,
                    title: filterVal,
                    filename: fileName,
                    columnsWidth: columnList,
                    styleCols1: this.styleCols1,
                    styleCols2: this.styleCols2,
                  });
                })
                .finally(() => {
                  this.styleCols1 = [];
                  this.styleCols2 = [];
                });
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Thất bại",
              type: "error",
            });
          });
    },
    submitForm() {
      if (this.valueDate.length < 2) {
        this.$message({
          message: "Vui lòng chọn khoảng thời gian",
          type: "warning"
        });
        return;
      }
      this.loadingButton = true;
      this.exportExcel();
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        this.loadingButton = false;
        loading.close();
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped></style>
